<template>
  <v-card>
    <!-- <v-card-title class="text-h5 lighten-2"> Tạo Link </v-card-title> -->
    <div class="contentlink">
      <h1>Rút gọn URL</h1>
      <h2>Dán URL cần rút gọn vào đây</h2>
      <div class="input-container d-flex mx-auto">
        <div class="w-100">
          <div class="text-left font-weight-bold">Link Gốc</div>
          <input
            name="link"
            v-model="form.originUrl"
            type="url"
            placeholder="Nhập liên kết vào đây"
          />
        </div>
      </div>
      <v-row class="d-flex mx-auto w-90">
        <v-col class="d-flex" cols="12" sm="6">
          <v-select
            :disabled="linkDetailByID ? true : false"
            v-model="form.domain"
            :items="listDomain"
            label="Tên miền"
          ></v-select>
        </v-col>

        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field
            :disabled="linkDetailByID ? true : false"
            v-model="form.path"
            label="Đường dẫn"
            placeholder="Nhập đường dẫn"
          ></v-text-field>
        </v-col>
      </v-row>
      <div v-show="loading">
        <v-progress-circular
          color="blue"
          indeterminate
          :size="40"
          :width="5"
        ></v-progress-circular>
      </div>
      <div v-if="shortenedLink" class="shortened-link d-flex justify-center">
        <strong>Liên kết rút gọn:</strong>
        <div class="px-2">{{ shortenedLink }}</div>
        <div style="cursor: pointer" class="mx-2" @click="clickCopy()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <g clip-path="url(#clip0_11781_284)">
              <path
                d="M13.3337 0.833252H3.33366C2.41699 0.833252 1.66699 1.58325 1.66699 2.49992V14.1666H3.33366V2.49992H13.3337V0.833252ZM15.8337 4.16659H6.66699C5.75033 4.16659 5.00033 4.91659 5.00033 5.83325V17.4999C5.00033 18.4166 5.75033 19.1666 6.66699 19.1666H15.8337C16.7503 19.1666 17.5003 18.4166 17.5003 17.4999V5.83325C17.5003 4.91659 16.7503 4.16659 15.8337 4.16659ZM15.8337 17.4999H6.66699V5.83325H15.8337V17.4999Z"
                fill="#2F80ED"
              />
            </g>
            <defs>
              <clipPath id="clip0_11781_284">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
    <v-card-actions class="text-right">
      <v-spacer></v-spacer>
      <v-btn @click="closeDialog()"> Hủy </v-btn>
      <v-btn :disabled="!form.originUrl" color="primary" @click="linkDetailByID ? updateLink() : createLink()">
        {{ linkDetailByID ? "Cập nhật" : "Tạo Link" }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory";
const ShortLinkRepository = RepositoryFactory.get("short_link");
export default {
  props: {
    linkDetailByID: {
      type: Object,
      default: () => {},
    },
    listDomain: {
      type: Array,
      default: () => {},
    }
  },
  data() {
    return {
      shortenedLink: null,
      loading: false,
      form: {
        originUrl: null,
        domain: null,
        path: null,
      },
    };
  },
  async created() {
    this.form.domain = this.listDomain[0];
  },
  watch: {
    form: {
      handler(val) {
        if (val && !this.linkDetailByID) {
          this.shortenedLink = null;
        }
      },
      deep: true,
    },
    linkDetailByID: {
      handler(val) {
        if (val) {
          this.form.path = val.urlId;
          this.form.domain = val.domain;
          this.form.originUrl = val.originUrl;
          this.shortenedLink = val.shortUrl;
        } else {
          this.form = {
            originUrl: null,
            domain: this.listDomain[0],
            path: null,
          };
          this.shortenedLink = null;
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.linkDetailByID) {
      this.form.path = this.linkDetailByID.urlId;
      this.form.domain = this.linkDetailByID.domain;
      this.form.originUrl = this.linkDetailByID.originUrl;
      this.shortenedLink = this.linkDetailByID.shortUrl;
    }
  },
  methods: {
    async createLink() {
      try {
        this.shortenedLink = null
        this.loading = true
        const response = await ShortLinkRepository.create(this.form);
        this.loading = false
        if (response && response.data) {
          this.shortenedLink = response.data.url;
          this.$emit('updateList')
        }
        if (response && response.error) {
          this.$swal({
            type: "error",
            icon: "error",
            title:
              response && response.error
                ? response.message
                : "Có lỗi xảy ra, vui lòng thử lại!",
            toast: true,
            showConfirmButton: false,
            timer: 1000,
            position: "top",
          });
        }
      } catch (error) {
        this.$swal({
          type: "error",
          icon: "error",
          title:
            error.response && error.response.data
              ? error.response.data.message
              : "Có lỗi xảy ra, vui lòng thử lại!",
          toast: true,
          showConfirmButton: false,
          timer: 1000,
          position: "top",
        });
      }
    },
    async updateLink() {
      try {
        this.shortenedLink = null
        this.loading = true
        const response = await ShortLinkRepository.update(this.linkDetailByID._id, this.form);
        this.loading = false
        if (response && response.data) {
          this.shortenedLink = this.linkDetailByID.shortUrl;
          this.$swal({
            type: "success",
            icon: "success",
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: "Cập nhật thành công!",
            position: "top",
          });
          this.$emit('updateList')
        }
        if (response && response.error) {
          this.shortenedLink = this.linkDetailByID.shortUrl;
          this.$swal({
            type: "error",
            icon: "error",
            title:
              response && response.error
                ? response.message
                : "Có lỗi xảy ra, vui lòng thử lại!",
            toast: true,
            showConfirmButton: false,
            timer: 1000,
            position: "top",
          });
        }
      } catch (error) {
         this.$swal({
          type: "error",
          icon: "error",
          title:
            error.response && error.response.data
              ? error.response.data.message
              : "Có lỗi xảy ra, vui lòng thử lại!",
          toast: true,
          showConfirmButton: false,
          timer: 1000,
          position: "top",
        });
      }
    },
    closeDialog() {
      this.form = {
        originUrl: null,
        domain: this.listDomain[0],
        path: null,
      };
      this.shortenedLink = null
      this.$emit("close");
    },
    clickCopy() {
      navigator.clipboard.writeText(this.shortenedLink).then(
        () => {
          this.$swal({
            type: "success",
            icon: "success",
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: "Sao chép thành công!",
            position: "top",
          });
        },
        (err) => {
          this.$swal({
            type: "error",
            icon: "error",
            title: "Sao chép thất bại!",
            toast: true,
            showConfirmButton: false,
            timer: 1000,
            position: "top",
          });
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.contentlink {
  background-color: #fff;
  text-align: center;
  padding: 30px 20px;
  width: 100%;
}

h1 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #e91e63;
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
}
h2 {
  font-size: 18px;
  margin-bottom: 10px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.input-container {
  width: 90%;
  input {
    width: 100%;
  }
}

input[type="url"] {
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  border-radius: 8px 0px 0px 8px;
}
input:focus {
  border: 1px solid #e91e63;
  outline: none;
}

.shortened-link {
  margin-top: 20px;
  font-size: 16px;
}

.w-90 {
  width: 90%;
}
</style>